import React, { useState } from 'react';

import { getConfig } from '@edx/frontend-platform';
import { FormattedMessage, useIntl } from '@edx/frontend-platform/i18n';
import { Hyperlink } from '@edx/paragon';
import PropTypes from 'prop-types';

import messages from '../../messages';
import RequiredRemark from '../../../common-components/RequiredRemark';
import { CheckedSVG } from '../../../assets/svgs';

const DetermineIcon = ({ hadFocus, errorMessage, value }) => {
  if(hadFocus && !value) return <RequiredRemark showAsError />
  if(!hadFocus && !errorMessage) return null;
  if(errorMessage) return <RequiredRemark showAsError />
  if(value) return <CheckedSVG color="#61a408" width={14} height={14} />
  return null;
}

const TermsOfService = (props) => {
  const [hadFocus, setHadFocus] = useState(false);

  const { formatMessage } = useIntl();
  const {
    errorMessage, onChangeHandler, value,
  } = props;

  const handleChange = (e) => {
    onChangeHandler(e);
    setHadFocus(true);
  }

  return(
    <div id="terms-of-service" className="pgn__form-group micro text-muted">
      <div className="form-field checkbox-terms_of_service has-checkbox">
        <input
          className={`input-block checkbox form-field--checkbox ${props.className}`}
          type="checkbox"
          id="tos"
          checked={value}
          name="terms_of_service"
          value={value}
          onChange={handleChange}
        />
        <label htmlFor="register-terms_of_service">
          <span className="label-text">
            <FormattedMessage
              id="register.page.terms.of.service"
              defaultMessage="I agree to the {platformName}&nbsp;{termsOfService} {required}"
              description="Text that appears on registration form stating terms of service.
                          It is a legal document that users must agree to."
              values={{
                platformName: getConfig().SITE_NAME,
                termsOfService: (
                  <Hyperlink variant="muted" showLaunchIcon={false} destination={getConfig().TOS_LINK || '#'} target="_blank">
                    {formatMessage(messages['terms.of.service'])}
                  </Hyperlink>
                ),
                required: <DetermineIcon hadFocus={hadFocus} errorMessage={errorMessage} value={value} />
              }}
            />
          </span>
          {/* <span id="register-terms_of_service-required-label" className="label-required hidden">
            (required)
          </span> */}
          {/* <span id="register-terms_of_service-validation-icon" className="icon fa" aria-hidden="true">
          </span> */}
        </label>
      </div>
      {/* <Form.Checkbox
        className="form-field--checkbox mt-1"
        id="tos"
        checked={value}
        name="terms_of_service"
        value={value}
        onChange={onChangeHandler}
      >
        <FormattedMessage
          id="register.page.terms.of.service"
          defaultMessage="I agree to the {platformName}&nbsp;{termsOfService}"
          description="Text that appears on registration form stating terms of service.
                       It is a legal document that users must agree to."
          values={{
            platformName: getConfig().SITE_NAME,
            termsOfService: (
              <Hyperlink variant="muted" destination={getConfig().TOS_LINK || '#'} target="_blank">
                {formatMessage(messages['terms.of.service'])}
              </Hyperlink>
            ),
          }}
        />
      </Form.Checkbox> */}
      {/* {errorMessage && (
        <Form.Control.Feedback type="invalid" className="form-text-size" hasIcon={false}>
          {errorMessage}
        </Form.Control.Feedback>
      )} */}
    </div>
  );
};

TermsOfService.defaultProps = {
  className: '',
  errorMessage: '',
  value: false,
};

TermsOfService.propTypes = {
  errorMessage: PropTypes.string,
  onChangeHandler: PropTypes.func.isRequired,
  value: PropTypes.bool,
  className: PropTypes.string,
};

export default TermsOfService;
